import SEO from '../components/SEO';
import React from 'react';

const Devis = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Estimation débarras gratuite en ligne | DEBECO"
        description="Estimez gratuitement le coût de votre débarras en quelques minutes. Service rapide en Savoie, Haute-Savoie et Ain."
        canonical="/devis"
      />
      {/* Hero - Compact */}
      <section className="hero-banner text-white py-8 md:py-12">
        <div className="container mx-auto px-4 text-center relative z-10">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">Estimez le coût de votre débarras</h1>
          <p className="text-lg text-blue-100 max-w-2xl mx-auto">
            Obtenez une estimation gratuite en quelques minutes
          </p>
        </div>
      </section>

      {/* Iframe Section */}
      <section className="flex-grow bg-gradient-to-br from-gray-50 to-blue-50 py-4 md:py-8">
        <div className="container mx-auto px-2 md:px-4 h-full">
          <iframe 
            src="https://devis-debarras.emergent.host/embed" 
            width="100%" 
            height="900" 
            frameBorder="0"
            title="Module de devis DEBECO"
            style={{
              borderRadius: '16px',
              maxWidth: '700px',
              margin: '0 auto',
              display: 'block'
            }}
          />
        </div>
      </section>
    </div>
  );
};

export default Devis;
